import {useDesignerSelector} from '@packages/systems/designer/flux';
import {selectSitePlan} from '@packages/systems/designer/site-data';
import {useConfig} from '@packages/systems/feature-config/client';
import {DYNAMIC_CONFIGS} from '@packages/systems/feature-config/shared';

/**
 * Default maximum number of email destinations allowed for free sites.
 * This can be overridden via dynamic config.
 */
const DEFAULT_FREE_EMAIL_DESTINATION_LIMIT = 50;

/**
 * Hook to get the form email destination limit for the current site.
 * @returns The email destination limit for sites on a free plan, or undefined if the site is not on a free plan.
 */
export const useFormEmailDestinationLimit = (): number | undefined => {
  const sitePlan = useDesignerSelector(selectSitePlan);
  const isFreePlan = sitePlan === 'free';

  // Get the limit from dynamic config
  const freeEmailDestinationLimitConfig = useConfig<{limit: number}>(
    DYNAMIC_CONFIGS.FREE_SITE_EMAIL_DESTINATION_LIMIT,
    {limit: DEFAULT_FREE_EMAIL_DESTINATION_LIMIT}
  );

  if (!isFreePlan) {
    return undefined;
  }
  return freeEmailDestinationLimitConfig.limit;
};
